import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconMoneyReceive: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.125 5.83331V9.99998C18.125 10.345 17.845 10.625 17.5 10.625C17.155 10.625 16.875 10.345 16.875 9.99998V5.83331C16.875 4.51915 16.3142 3.95831 15 3.95831H5C3.68583 3.95831 3.125 4.51915 3.125 5.83331V12.5C3.125 13.8141 3.68583 14.375 5 14.375H11.6667C12.0117 14.375 12.2917 14.655 12.2917 15C12.2917 15.345 12.0117 15.625 11.6667 15.625H5C2.985 15.625 1.875 14.515 1.875 12.5V5.83331C1.875 3.81831 2.985 2.70831 5 2.70831H15C17.015 2.70831 18.125 3.81831 18.125 5.83331ZM4.16667 9.16665C4.16667 9.62665 4.54 9.99998 5 9.99998C5.46 9.99998 5.83333 9.62665 5.83333 9.16665C5.83333 8.70665 5.46 8.33331 5 8.33331C4.54 8.33331 4.16667 8.70665 4.16667 9.16665ZM10 6.04165C11.7233 6.04165 13.125 7.44331 13.125 9.16665C13.125 10.89 11.7233 12.2916 10 12.2916C8.27667 12.2916 6.875 10.89 6.875 9.16665C6.875 7.44331 8.27667 6.04165 10 6.04165ZM10 7.29165C8.96583 7.29165 8.125 8.13248 8.125 9.16665C8.125 10.2008 8.96583 11.0416 10 11.0416C11.0342 11.0416 11.875 10.2008 11.875 9.16665C11.875 8.13248 11.0342 7.29165 10 7.29165ZM17.0583 14.5583L16.4583 15.1583V12.5C16.4583 12.155 16.1783 11.875 15.8333 11.875C15.4883 11.875 15.2083 12.155 15.2083 12.5V15.1575L14.6084 14.5575C14.3642 14.3133 13.9683 14.3133 13.7242 14.5575C13.48 14.8016 13.48 15.1975 13.7242 15.4417L15.3908 17.1083C15.4483 17.1658 15.5175 17.2117 15.5942 17.2433C15.6708 17.275 15.7517 17.2916 15.8325 17.2916C15.9134 17.2916 15.995 17.275 16.0708 17.2433C16.1475 17.2117 16.2167 17.1658 16.2742 17.1083L17.9408 15.4417C18.185 15.1975 18.185 14.8016 17.9408 14.5575C17.6975 14.3141 17.3025 14.3141 17.0583 14.5583Z"
      fill={color}
    />
  </svg>
);

export default IconMoneyReceive;
